import { useState, useCallback } from 'react';

/**
 * Custom hook to track the execution state of async operations.
 * This provides a shared state that can be used across components to show
 * loading states and disable UI elements during async operations.
 */
export const useExecutionTracker = () => {
  const [isExecuting, setIsExecuting] = useState(false);

  const executeWithTracking = useCallback(
    async <T>(asyncOperation: () => Promise<T>): Promise<T> => {
      setIsExecuting(true);
      try {
        return await asyncOperation();
      } finally {
        setIsExecuting(false);
      }
    },
    []
  );

  return {
    isExecuting,
    executeWithTracking,
  };
};
